import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { fetchSystemInfo } from '../api'
import { SystemInfo } from '../models'
import { useFarmContext } from 'src/Elements/Farm'
import { usePortalQuery } from 'src/Libs/api'

interface ReturnType {
  systemInfo: SystemInfo | null
  isSystemInfoLoading: boolean
}

export const systemInfoQueryKey = (storageId: string | undefined, isFarmMasterSelected: boolean) =>
  ['systemInfo', storageId, isFarmMasterSelected] as const
/**
 * Custom hook to fetch system information.
 *
 * @param storageId
 * @returns
 */
const useSystemInfoTanQuery = (storageId: string | undefined): ReturnType => {
  const authFetch = useAuthFetchWithResponse()
  const { isFarmMasterSelected, farmClients, isLoading: isFarmLoading } = useFarmContext()
  const isEnabled = !!storageId && !isFarmLoading

  const { data: systemInfo, isLoading } = usePortalQuery({
    queryKey: systemInfoQueryKey(storageId, isFarmMasterSelected),
    queryFn: () => fetchSystemInfo(storageId ?? '', authFetch, isFarmMasterSelected, farmClients),
    enabled: isEnabled,
  })

  const isSystemInfoLoading = !!storageId && (isLoading || isFarmLoading)

  return { systemInfo: systemInfo || null, isSystemInfoLoading }
}

export default useSystemInfoTanQuery
